var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pt-0",attrs:{"cols":"0","md":"12","sm":"12","lg":"12","xl":"12"}},[_c('session-title',{staticClass:"pt-8 px-10 pb-5",attrs:{"title":"Artigos"}})],1),_c('v-col',[_c('articles-grid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }